import React, { useState } from "react";

export default function Icons({
    name,
    width,
    height,
    fill,
    hoverColor,
    cardIndex,
    cardName
}) {
    return (
        <>
            {name === "phone-number" ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#168DEF" d="M19.56 14.81a10.22 10.22 0 0 1-3.21-.51 1.47 1.47 0 0 0-1.43.3l-2 1.53a11.18 11.18 0 0 1-5-5l1.48-2a1.46 1.46 0 0 0 .36-1.47 10.23 10.23 0 0 1-.51-3.21A1.45 1.45 0 0 0 7.75 3H4.44A1.45 1.45 0 0 0 3 4.44 16.57 16.57 0 0 0 19.56 21 1.45 1.45 0 0 0 21 19.56v-3.3a1.45 1.45 0 0 0-1.44-1.45Z" /></svg>

            ): name === "arrow" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 25 15"
                  fill={fill ? fill : "#000"}
                >
                  <path
                    d="M2 7.6239H23.3547"
                    stroke={fill ? fill : "#202020"}
                    strokeWidth="2.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.2539 12.9572L23.3552 7.6239"
                    stroke={fill ? fill : "#202020"}
                    strokeWidth="2.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.2539 2.29056L23.3552 7.62389"
                    stroke={fill ? fill : "#202020"}
                    strokeWidth="2.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                " "
            )}
        </>
    );
}